/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { shape } from 'prop-types';
import { MESSAGE_TYPE_REQUEST, MESSAGE_TYPE_FINISH } from 'Constants/message-types';

import MessageFinishConsult from './MessageFinishConsult/MessageFinishConsult';
import MessageRequestConsult from './MessageRequestConsult/MessageRequestConsult';
import MessageBot from './MessageBot';

const MessageBotHOC = props => {
  const { message, isDoctor, isBot } = props;
  const { type } = message;
  if (type === MESSAGE_TYPE_FINISH) {
    return <MessageFinishConsult message={message} isDoctor={isDoctor} isBot={isBot} />;
  }
  if (type === MESSAGE_TYPE_REQUEST) {
    return <MessageRequestConsult message={message} isDoctor={isDoctor} isBot={isBot} />;
  }

  return <MessageBot {...props} />;
};

MessageBotHOC.propTypes = {
  message: shape({}).isRequired,
};

export default MessageBotHOC;
